<template>
  <nav>
    <ul class="nav-list">
      <li class="logo">
        <a href="/">
          <img
            :src="require('images/logo.png')"
            alt="Reeracoen Freelance Recruiting Business"
          />
        </a>
      </li>
      <li v-if="showLocale" class="locale-selector">
        <div class="languages">
          <sui-dropdown :text="lang.toUpperCase()" button pointing="top right">
            <sui-dropdown-menu>
              <sui-dropdown-item @click="setLocale('en')"
                >English
              </sui-dropdown-item>
              <sui-dropdown-item @click="setLocale('th')"
                >Thai
              </sui-dropdown-item>
              <sui-dropdown-item @click="setLocale('ja')"
                >Japanese
              </sui-dropdown-item>
            </sui-dropdown-menu>
          </sui-dropdown>
        </div>
      </li>
    </ul>
  </nav>
</template>
<script>
import Vue from 'vue'
import SuiVue from 'semantic-ui-vue'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'
Vue.use(SuiVue)
Vue.use(VueToast)

import { isEmpty, isNull } from 'lodash'

// I18n
import I18n from 'i18n/i18n'
import 'i18n/views/layouts/en'
import { i18n } from 'mixins/i18n'
window.I18n = I18n

// Set locale from URL path
const _pathLocale = window.location.pathname.split('/').filter(Boolean)[0]
I18n.locale = ['en', 'th', 'ja'].includes(_pathLocale) ? _pathLocale : 'en'

import settings from 'consts/settings.js.erb'
import helpers from 'mixins/helpers'

const ViewProps = window._application.props

export default {
  mixins: [i18n, helpers],

  props: {
    showLocale: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      flash: ViewProps.flash,
      lang: I18n.locale,
      mailAddress: settings.contact.email,
      telNo: settings.contact.tel,
    }
  },

  mounted: function () {
    if (!isEmpty(this.flash)) {
      this.$toast.open({
        message: this.flash[0].message,
        type: this.flash[0].key,
        duration: 5000,
        dismissible: true,
        position: 'top-right',
      })
    }
  },

  methods: {
    setLocale(locale) {
      const parts = window.location.pathname.split('/').filter(Boolean)
      const supported = ['en', 'th', 'ja']
      if (supported.includes(parts[0])) {
        parts[0] = locale
      } else {
        parts.unshift(locale)
      }
      window.location.href = '/' + parts.join('/') + window.location.search
    },
  },
}
</script>
<style scoped lang="scss">
@import 'stylesheets/global';

nav {
  .nav-list {
    align-items: center;
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.5rem 2rem;

    @include sp {
      padding: 1.5rem 1rem;
    }

    .logo {
      img {
        width: 200px;

        @include sp {
          width: 120px;
        }
      }
    }

    .locale-selector {
      .languages {
        ::v-deep .ui.button {
          font-family: 'Poppins', sans-serif;
        }

        ::v-deep .ui.dropdown {
          background-color: #7baff8;
          padding: 0.25rem;

          .text {
            color: #fff;
            font-size: 0.8em;
            font-weight: 600;
          }

          > .dropdown.icon {
            display: none;
          }

          > .menu::after {
            display: none;
          }

          .menu {
            border: 1px solid #000;
            border-radius: 0;
            margin-top: 0.5rem;
            width: 8rem;

            > .item {
              font-size: 0.8em;
            }
          }
        }
      }
    }
  }
}
</style>
